import { __rest, __assign } from '../../_virtual/_tslib.js';
import React, { useState, useRef } from 'react';
import Text from './Text.js';
import Password from './Password.js';
import Count from './Count.js';
import DateInput from './Date.js';
import PhoneNumber from './PhoneNumber.js';
import { InputStyleTypeEnum } from './types.js';
import { StyledInputWrapper } from './style.js';

function Input(_a) {
    var styleType = _a.styleType, seconds = _a.seconds, style = _a.style, validate = _a.validate, onResetIconClick = _a.onResetIconClick, props = __rest(_a, ["styleType", "seconds", "style", "validate", "onResetIconClick"]);
    var _b = useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var inputRef = useRef(null);
    switch (styleType) {
        case InputStyleTypeEnum.Text:
            return (React.createElement(StyledInputWrapper, { style: style, onFocus: function () {
                    setIsFocused(true);
                }, onBlur: function (e) {
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                        setIsFocused(false);
                        if (validate) {
                            validate();
                        }
                    }
                } },
                React.createElement(Text, __assign({ isFocused: isFocused, inputRef: inputRef, onResetIconClick: function () {
                        onResetIconClick();
                    } }, props))));
        case InputStyleTypeEnum.Password:
            return (React.createElement(StyledInputWrapper, { style: style, onFocus: function () {
                    setIsFocused(true);
                }, onBlur: function (e) {
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                        setIsFocused(false);
                        if (validate) {
                            validate();
                        }
                    }
                } },
                React.createElement(Password, __assign({ isFocused: isFocused, inputRef: inputRef, onResetIconClick: onResetIconClick }, props))));
        case InputStyleTypeEnum.Count:
            return (React.createElement(StyledInputWrapper, { style: style, onFocus: function () {
                    setIsFocused(true);
                }, onBlur: function (e) {
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                        setIsFocused(false);
                        if (validate) {
                            validate();
                        }
                    }
                } },
                React.createElement(Count, __assign({}, props, { isFocused: isFocused, inputRef: inputRef, seconds: seconds !== null && seconds !== void 0 ? seconds : 0, onResetIconClick: onResetIconClick }))));
        case 'date':
            return (React.createElement(StyledInputWrapper, { style: style, onFocus: function () {
                    setIsFocused(true);
                }, onBlur: function (e) {
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                        setIsFocused(false);
                        if (validate) {
                            validate();
                        }
                    }
                } },
                React.createElement(DateInput, __assign({ isFocused: isFocused, inputRef: inputRef, onResetIconClick: function () {
                        onResetIconClick();
                    } }, props))));
        case 'phoneNumber':
            return (React.createElement(StyledInputWrapper, { style: style, onFocus: function () {
                    setIsFocused(true);
                }, onBlur: function (e) {
                    if (!e.currentTarget.contains(e.relatedTarget)) {
                        setIsFocused(false);
                        if (validate) {
                            validate();
                        }
                    }
                } },
                React.createElement(PhoneNumber, __assign({ isFocused: isFocused, inputRef: inputRef, onResetIconClick: function () {
                        onResetIconClick();
                    } }, props))));
        default:
            return null;
    }
}

export { Input as default };
